import { Injectable } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';

import * as WinnerActions from './winner.actions';
import * as WinnerSelectors from './winner.selectors';

@Injectable()
export class WinnerFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(WinnerSelectors.getWinnerLoaded));
  loading$ = this.store.pipe(select(WinnerSelectors.getWinnerLoading));
  processing$ = this.store.pipe(select(WinnerSelectors.getWinnerProcessing));
  data$ = this.store.pipe(select(WinnerSelectors.getData));
  error$ = this.store.pipe(select(WinnerSelectors.getWinnerError));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  load(data: { eventInstanceId: string; playInstanceId: string }) {
    this.store.dispatch(WinnerActions.load(data));
  }

  confirmWinner() {
    this.store.dispatch(WinnerActions.confirm());
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
